module.exports = __webpack_public_path__ + "static/media/hero-mobile.931a41d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-mobile.jpg
// module id = 198
// module chunks = 51